














































import { QVueGlobals } from 'quasar';
import { Component, Prop, Vue } from 'vue-property-decorator';
import RemaxToolbar from '@/components/RemaxToolbar.vue';
import Drawer from '../views/Drawer.vue';
import Map from '../views/Map.vue';
import PopupMultiListing from '@/components/PopupMultiListing.vue';
import PopupParcel from '@/components/PopupParcel.vue';
import PopupSingleListing from '@/components/PopupSingleListing.vue';
import FilterDialog from '@/components/FilterDialog.vue';
import ListingDetailsDialog from '@/components/ListingDetailsDialog.vue';
import LoginPromptDialog from '@/components/LoginPromptDialog.vue';
import CrimePanel from '@/components/CrimePanel.vue';
import ParcelDetailsDialog from '@/components/ParcelDetailsDialog.vue';
import BookViewingDialog from '@/components/BookViewingDialog.vue';
import LayerManager from '@/components/LayerManager.vue';
import FavouriteManager from '@/components/FavouriteManager.vue';
import ShareDialog from '@/components/ShareDialog.vue';
import FilterManager from '@/components/FilterManager.vue';
import FilterManageButton from '@/components/FilterManageButton.vue';
import MeasureTool from '@/components/MeasureTool.vue';
import ListingFilter from '@/components/ListingFilter.vue';
import GeoLocation from '@/components/GeoLocation.vue';
import WalkTimes from '@/components/WalkTimes.vue';
import FilterSaveDialog from '@/components/FilterSaveDialog.vue';
import TryMobileBanner from '@/components/TryMobileBanner.vue';
import ListingUtil from '../utils/ListingUtil';
import Auth from '@/auth/Auth';

// @ts-ignore - this thing aint got no types?!
import LightBox from 'vue-image-lightbox';
import 'vue-image-lightbox/dist/vue-image-lightbox.min.css';

@Component({
    components: {
        RemaxToolbar,
        Drawer,
        Map,
        PopupMultiListing,
        PopupParcel,
        PopupSingleListing,
        FilterDialog,
        ListingDetailsDialog,
        LoginPromptDialog,
        CrimePanel,
        ParcelDetailsDialog,
        BookViewingDialog,
        LayerManager,
        FavouriteManager,
        ShareDialog,
        FilterManager,
        FilterManageButton,
        MeasureTool,
        ListingFilter,
        GeoLocation,
        WalkTimes,
        LightBox,
        FilterSaveDialog,
        TryMobileBanner,
    },
})
export default class LayoutDefault extends Vue {
    public IsLightBoxOn: boolean = false;

    get lbMedia() {
        const media: any = [];
        if (this.$store.state.listings.selectedListingDetail) {
            if (this.$store.state.listings.selectedListingDetail.PropertyImages.length > 0) {
                const slides = this.$store.state.listings.selectedListingDetail.PropertyImages;
                for (let i = 0; i < slides.length; i++) {
                    slides[i] = ListingUtil.removeMapPostfixToImage(slides[i]);
                }
                for (const url of slides) {
                    media.push({
                        thumb: url,
                        src: url,
                    });
                }
            } else {
                const slide = this.config.imageRoot + this.config.placeholdListingImg;
                media.push({
                    thumb: slide,
                    src: slide,
                });
            }
        }
        return media;
    }

    get showTryMobileBanner() {
        if (!(this.$q.platform.is.android || this.$q.platform.is.ios)) {
            return false;
        }
        if (this.$store.state.isMobileBannerDismissed) {
            return false;
        }
        return true;
    }

    get config() {
        return this.$store.state.config;
    }

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'notify') {
            this.notify(action.payload);
        }
        if (action.type === 'showLightBox') {
            this.onShowLightBox();
        }
    });

    public mounted() {
        console.log('LayoutDefault: mounted()');
        Auth.checkAccount();
    }

    public notify(message: any) {
        this.$q.notify(message);
    }

    public onShowLightBox() {
        // @ts-ignore - man I really want a lightbox with types

        this.$refs.lightbox.showImage(0);
        this.IsLightBoxOn = true;
    }

    public onClose() {
        this.IsLightBoxOn = false;
    }
}

